// src/hooks/useDropdownData.js
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from 'react-toastify'; 

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = Cookies.get("token");

const fetchDropdownData = async (endpoint, key) => {
  try {
    const res = await axios.get(`${BASE_URL}${endpoint}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.[key] || [];
  } catch (error) {
    console.error("Failed to fetch dropdown data for", endpoint, error);
    return [];
  }
};

// drop down hook for Degree
export const useDegrees = () => {
  const [degrees, setDegrees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDropdownData("/master/getDegree", "degree").then((data) => {
      setDegrees(data);
      setLoading(false);
    });
  }, []);

  return { degrees, loading };
};

// drop down hook for college
export const useColleges = () => {
  const [colleges, setColleges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDropdownData("/master/getColleges", "colleges").then((data) => {
      setColleges(data);
      setLoading(false);
    });
  }, []);

  return { colleges, loading };
};

// drop down hook for program
export const useProgrammes = () => {
  const [programmes, setProgrammes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProgrammes = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getProgramme`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.programme) {
          setProgrammes(res.data.programme);
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch programmes:", error);
        setLoading(false);
      }
    };

    fetchProgrammes();
  }, []);

  return { programmes, loading };
};


export const usePrograms = useProgrammes;

// hook for programyear 
export const useProgrammeYears = () => {
  const [programmeYears, setProgrammeYears] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProgrammeYears = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getProgrammeYear`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.programme) {
          setProgrammeYears(res.data.programme);
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch programme years:", error);
        setLoading(false);
      }
    };

    fetchProgrammeYears();
  }, []);

  return { programmeYears, loading };
};

export const useProgramYears = useProgrammeYears;

// hook for academic years 
export const useAcademicYears = () => {
  const [academicYears, setAcademicYears] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getAcademicYear`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Academic Years response", res.data);
        setAcademicYears(res.data?.academicyear || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch academic years", error);
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { academicYears, loading };
};

// hook for credit hours 
export const useCreditHours = () => {
  const [creditHours, setCreditHours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getCreditHours`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Credit Hours response", res.data);
        setCreditHours(res.data?.creditHours || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch credit hours", error);
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { creditHours, loading };
};

// hook for semester 
export const useSemesters = () => {
  const [semesters, setSemesters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSemesters = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getSemster`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.semster) {
          setSemesters(res.data.semster);
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch semesters:", error);
        setLoading(false);
      }
    };

    fetchSemesters();
  }, []);

  return { semesters, loading };
};

// hook for discipline 
export const useDisciplines = () => {   
  const [disciplines, setDisciplines] = useState([]);   
  const [loading, setLoading] = useState(true);    

  useEffect(() => {     
    const fetchDisciplines = async () => {       
      try {         
        const token = Cookies.get("token");         
        const res = await axios.get(`${BASE_URL}/master/getDiscipline`, {           
          headers: { Authorization: `Bearer ${token}` },         
        });         
        
        console.log("Disciplines API response:", res.data);         
        
        let disciplinesData = [];
        
        if (res.data) {
          disciplinesData = res.data.disciplines || 
                           res.data.discipline || 
                           res.data.details || 
                           res.data.data || 
                           res.data;
                           
          if (!Array.isArray(disciplinesData) && typeof disciplinesData === 'object') {
           
            const possibleArrays = Object.values(disciplinesData).filter(Array.isArray);
            disciplinesData = possibleArrays.length > 0 ? possibleArrays[0] : [];
          }
          
         
          if (!Array.isArray(disciplinesData)) {
            console.warn("Disciplines data is not an array:", disciplinesData);
            disciplinesData = [];
          }
        }
        
        console.log("Final disciplines data:", disciplinesData);
        setDisciplines(disciplinesData);
        
      } catch (error) {         
        console.error("Failed to fetch disciplines:", error);
        setDisciplines([]); 
      } finally {
        setLoading(false);       
      }     
    };     
    
    fetchDisciplines();   
  }, []);    

  return { disciplines, loading }; 
};

// hooks for component master 
export const useComponentMasters = (degreeId) => {
  const [componentMasters, setComponentMasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = Cookies.get("token");

  useEffect(() => {
    const fetchComponentMasters = async () => {
      if (!degreeId) {
        setLoading(false);
        return;
      }
      try {
        const res = await axios.post(
          `${BASE_URL}/masters/getComponentMaster`,
          { degree: parseInt(degreeId) },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setComponentMasters(res.data?.details || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch component masters", error);
        setComponentMasters([]);
        setLoading(false);
      }
    };

    fetchComponentMasters();
  }, [degreeId]);

  return { componentMasters, loading };
};

// Edu Course Types hook
export function useEduCourseTypes() {
  const [eduCourseTypes, setEduCourseTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEduCourseTypes = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}/masters/getEduCoursesType`,
          { user: 1 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = res.data?.details || [];
        const formatted = data.map((item) => ({
          id: item.id,
          exName: item.exEduCourseTypeName,
        }));
        setEduCourseTypes(formatted);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch Edu Course Types", error);
        setEduCourseTypes([]);
        setLoading(false);
      }
    };

    fetchEduCourseTypes();
  }, []);

  return { eduCourseTypes, loading };
}

// Categories hook 
export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/master/getCategory`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = res.data?.category || [];
        const formatted = data.map((item) => ({
          id: item.id,
          exName: item.exCategoryName,
        }));

        setCategories(formatted);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch Categories', error);
        setCategories([]);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading };
}

//  Department Hook 
export const useDepartments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getDepartment`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("📦 Department response:", res.data);
        setDepartments(res.data?.department || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch departments", error);
        setLoading(false);
      }
    };
    fetchDepartments();
  }, []);

  return { departments, loading };
};

//  Staff Type Hook 
export const useStaffTypes = () => {
  const [staffTypes, setStaffTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStaffTypes = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getStaffType`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("📦 StaffType response:", res.data);
        setStaffTypes(res.data?.stafftype || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch staff types", error);
        setLoading(false);
      }
    };
    fetchStaffTypes();
  }, []);

  return { staffTypes, loading };
};

// Designations hook
export const useDesignations = () => {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getDesignation`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDesignations(res.data?.designation || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch designations", error);
        setLoading(false);
      }
    };
    fetchDesignations();
  }, []);

  return { designations, loading };
};

// Registration type hook 
export const useRegistrationTypes = () => {
  const [registrationTypes, setRegistrationTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegistrationTypes = async () => {
      try {
        const token = Cookies.get("token");
        const response = await axios.get(`${BASE_URL}/master/getRegistrationType`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data && response.data.registrationType) {
          setRegistrationTypes(response.data.registrationType);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching registration types:", error);
        setLoading(false);
      }
    };

    fetchRegistrationTypes();
  }, []);

  return { registrationTypes, loading };
};

// Sections hook 
export const useSections = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDropdownData("/master/getSection", "section").then((data) => {
      setSections(data);
      setLoading(false);
    });
  }, []);

  return { sections, loading };
};


// Hook for Courses
export const useCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getCourses`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("📚 Courses response:", res.data);
        setCourses(res.data?.courses || res.data?.course || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch courses", error);
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  return { courses, loading };
};


// Hook for Exam Announcements
export const useExamAnnouncements = () => {
  const [examAnnouncements, setExamAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExamAnnouncements = async () => {
      try {
        const token = Cookies.get("token");
        
        const res = await axios.get(`${BASE_URL}/academic/getAllExamAnnouncement`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("📢 Exam Announcements response:", res.data);
      
        setExamAnnouncements(res.data?.examannouncement || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch exam announcements", error);
        setLoading(false);
      }
    };
    fetchExamAnnouncements();
  }, []);

  return { examAnnouncements, loading };
};


// Hook for Staff 
export const useStaff = (degreeId) => {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!degreeId) {
      setStaff([]); 
      return;
    }

    const fetchStaff = async () => {
      setLoading(true);
      try {
        const token = Cookies.get("token");
      
        const url = `${BASE_URL}/academic/getAllStaff?degree=${degreeId}`;
        
        console.log("Fetching staff with URL:", url); 
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        console.log(" Staff response for degree " + degreeId + ":", res.data);

        const staffList = res.data?.Staff || res.data?.staff || [];
        
        setStaff(staffList);
      } catch (error) {
        console.error(`Failed to fetch staff for degree ${degreeId}:`, error);
        toast.error(`Could not fetch staff for the selected degree.`);
        setStaff([]); 
      } finally {
        setLoading(false); 
      }
    };

    fetchStaff();
  }, [degreeId]); 

  return { staff, loading };
};

export const useRoomMaster = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoomMaster = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getRoomMaster`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(" Room Master response:", res.data);
        setRooms(res.data?.rooms || []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch room master data", error);
        setLoading(false);
      }
    };
    fetchRoomMaster();
  }, []);

  return { rooms, loading };
};

// fees type hook 
export const useFeeType = () => {
  const [feeTypes, setFeeTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeeTypes = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BASE_URL}/master/getFeeType`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Fee Type response:", res.data);
        
        const feeTypeData = res.data?.feetype || [];
        console.log("Fee Types count:", feeTypeData.length);
        
        setFeeTypes(Array.isArray(feeTypeData) ? feeTypeData : []);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch fee type data", error);
        setFeeTypes([]);
        setLoading(false);
      }
    };
    fetchFeeTypes();
  }, []);

  return { feeTypes, loading };
};  